export default __webpack_public_path__ + "static/media/subject-math.1b341d5a.webp";